import fetch from '../../../../../utils/fetch'
import * as types from './mutation_types'

export const reset = ({ commit }) => {
  commit(types.THUMBNAIL_DELETE_RESET)
}

export const del = ({ commit, state }, thumbnailId) => {
  commit(types.THUMBNAIL_DELETE_RESET)
  commit(types.THUMBNAIL_DELETE_SET_LOADING, true)

  return fetch(thumbnailId, { method: 'DELETE' })
    .then(() => {
      commit(types.THUMBNAIL_DELETE_SET_DELETED, thumbnailId)
    })
    .catch((e) => {
      commit(types.THUMBNAIL_DELETE_SET_ERROR, e.message)
    })
    .finally(() => {
      commit(types.THUMBNAIL_DELETE_SET_LOADING, false)
    })
}
